import { createAsyncThunk } from '@reduxjs/toolkit';
import NetworksService from '@/services/NetworksService';
import CompanyService from '@/services/CompanyService';

const handler = (name, asyncFunction) =>
  createAsyncThunk(`Networks/${name}`, (arg, thunkAPI) =>
    asyncFunction(arg, thunkAPI)
  );

export const searchNetworks = handler('searchNetworks', (params) =>
  NetworksService.searchCompanies(params)
);

export const createNetwork = handler('createNetwork', (params) =>
  NetworksService.createNetwork(params)
);

export const getNetworksByStatus = handler(
  'getNetworksByStatus',
  async (params, thunkAPI) => {
    const response = await NetworksService.getNetworksByStatus(params);
    const company_id = thunkAPI.getState().UserSlice?.data?.company_id;
    return { ...response, company_id };
  }
);

export const fetchNetwork = handler('fetchNetwork', (networkId) =>
  NetworksService.getNetwork(networkId)
);

export const updateNetwork = handler('updateNetwork', ({ networkId, data }) =>
  NetworksService.updateNetwork(networkId, data)
);

export const addInvitation = handler(
  'addInvitation',
  ({ invited_company, network }) =>
    NetworksService.addInvitation({ invited_company, network })
);

export const deleteInvitation = handler(
  'deleteInvitation',
  ({ invitationId, networkId }) =>
    NetworksService.deleteInvitation(invitationId).then((response) => ({
      ...response,
      networkId,
    }))
);

export const rejectInvitation = handler(
  'rejectInvitation',
  ({ invitationId, networkId }) =>
    NetworksService.rejectInvitation(invitationId, networkId)
);

export const acceptInvitation = handler(
  'acceptInvitation',
  async ({ invitationId, networkId }, thunkAPI) => {
    const response = await NetworksService.acceptInvitation(
      invitationId,
      networkId
    );
    const fullName = thunkAPI.getState().UserSlice?.data?.full_name;
    return { ...response, _acceptedByFullName: fullName };
  }
);

export const deleteNetwork = handler('deleteNetwork', (networkId) =>
  NetworksService.deleteNetwork(networkId)
);

export const searchAgents = handler('searchAgents', ({ q, networkId }) =>
  NetworksService.searchAgents({ q, networkId })
);

export const getNetworkSummary = handler('getNetworkSummary', async () => {
  const response = await NetworksService.getNetworkSummary();
  return response;
});

export const requestNetworksUpgrade = handler(
  'requestNetworksUpgrade',
  async () => {
    const data = await NetworksService.requestNetworksUpgrade();
    return data;
  }
);

export const getNetworksUpgradePending = handler(
  'getNetworksUpgradePending',
  async () => {
    const data = await CompanyService.getUpgradePending();
    return data;
  }
);
